<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="success" @click="setLimit" :style="isMB?'margin-bottom:6px;':''">批量设置通话时长上限</el-button>
        <el-button size="mini" class="filter-item" @click="importFile" type="success" plain v-if="!isMB">导入</el-button>
        <el-button size="mini" class="filter-item" @click="onExport" type="primary" plain v-if="!isMB">导出</el-button>
        <el-button size="mini" class="filter-item" type="primary" @click="create">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        :width="isMB?'60':'90'"
      >
        <template slot-scope="{row}">
          <el-button type="text" @click="editById(row.PhoneId)" size="medium" icon="el-icon-edit-outline" title="编辑"></el-button>
        </template>
      </el-table-column>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <import-dialog ref="importDialog" @upload-success="reload" />
    <limit-dialog ref="limitDialog" @setLimit="subLimit"></limit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/consume/phonemanage/list";
import editDialog from "@/components/consume/phonemanage/editDialog";
import limitDialog from "@/components/consume/phonemanage/limitDialog";
import importDialog from "@/components/consume/phonemanage/importDialog";

export default {
  name: "phonemanage",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    limitDialog,
    importDialog
  },
  data() {
    return {
      api: require("@/api/consume/phonemanage").default,
      isMB: this.$store.state.isMB,
      selectedRows: [],
    }
  },
  methods: {
    setLimit() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要设置的话机");
        return;
      }
      this.selectedRows = rows
      this.$refs.limitDialog.open();
    },
    subLimit(min) {
      console.log('min',min)
      let rows = this.selectedRows
      rows.forEach(e => {
        e.UpperLimit = min
      });
      this.api.updateUpperLimit(rows).then(res => {
        if(res.Code==0) {
          this.$message.success("修改成功")
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    onExport() {
      this.$refs.list.export();
    },
    importFile() {
      this.$refs.importDialog.open();
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.PhoneId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>